import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  result: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  result
}) => {
  return <div className="relative bg-navy border-l-[3px] border-gold rounded-lg p-6 shadow-lg h-full flex flex-col" style={{
    borderLeftColor: '#D4AF37',
    backgroundColor: '#0A1628'
  }} data-id="element-145">
      <Quote className="text-gold mb-4" size={36} fill="#D4AF37" fillOpacity={0.15} data-id="element-146" />
      <p className="text-lg text-white leading-relaxed mb-6 flex-1" data-id="element-147">
        "{quote}"
      </p>
      <div className="space-y-2 mt-auto" data-id="element-148">
        <p className="text-gold text-base font-medium" data-id="element-149">{name}</p>
        <p className="text-gold font-bold text-lg" data-id="element-150">{result}</p>
      </div>
    </div>;
};
export const Testimonials: React.FC = () => {
  return <SectionWrapper data-id="element-151">
      <h2 className="text-3xl md:text-4xl font-bold text-gold mb-12 text-center" data-id="element-152">
        Lo Que Dicen Quienes Ya Lo Usaron
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-153">
        <TestimonialCard quote="Tenía mi cita en 3 días y estaba paralizado del miedo. Leí el protocolo la noche anterior, practiqué las 7 respuestas frente al espejo y entré a la embajada con un plan claro. La entrevista duró menos de 4 minutos. Salí con mi visa aprobada." name="— Carlos M., Colombia" result="✅ Visa B1/B2 Aprobada" data-id="element-154" />
        <TestimonialCard quote="Ya me habían negado la visa una vez. Esta vez llegué con el Método MRA preparado. El oficial me hizo 5 preguntas y yo respondí cada una en menos de 10 palabras. No hubo repreguntas. No hubo dudas. Salí con mi visa ese mismo día." name="— Valentina R., Venezuela" result="✅ Visa B1/B2 Aprobada" data-id="element-155" />
      </div>
    </SectionWrapper>;
};